<template>
  <list-form :can-back="true" @submit.prevent="doSearch" @reset.prevent="doReset" @back="toViewer">
    <template #search-form>
      <div class="row">
        <vuex-text-search-item class="col" label="氏名" bind="name" />
        <vuex-text-search-item class="col" label="氏名（カナ）" bind="name_kana" />
      </div>
      <div class="row">
        <vuex-text-search-item class="col" label="店舗名" bind="office" />
        <vuex-text-search-item class="col" label="部署名" bind="department" />
      </div>
      <div class="row">
        <vuex-select-search-item class="col" label="管理者" bind="is_supervisor"
                                 :options="$constant.BROKER_SUPERVISOR_LIST"
        />
        <div class="form-group row col" />
      </div>
      <vuex-include-freeze-search-item bind="include_freeze" />
    </template>
    <template #table>
      <div v-if="brokers.length">
        <plain-table :headers="tableHeaders" :data="tableData" :can-register="is_supervisor" :pagination="paginationStatus" :sort="sortStatus"
                     @select="toDetail" @register="toInvite" @change-page="doChangePage" @sort="doSort"
        />
      </div>
      <danger-alert v-else message="表示する社員がいませんでした。" />
    </template>
  </list-form>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ListForm from '@/views/templates/forms/ListForm'
import VuexTextSearchItem from "@/views/molecules/searchItems/VuexTextSearchItem";
import VuexSelectSearchItem from "@/views/molecules/searchItems/VuexSelectSearchItem";
import VuexIncludeFreezeSearchItem from '@/views/molecules/searchItems/VuexIncludeFreezeSearchItem'
import PlainTable from '@/views/molecules/PlainTable';
import DangerAlert from '@/views/atoms/alerts/DangerAlert'

export default {
  name: 'BrokerList',
  components: {
    ListForm,
    VuexTextSearchItem,
    VuexSelectSearchItem,
    VuexIncludeFreezeSearchItem,
    PlainTable,
    DangerAlert,
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'broker_index'
  },
  inject: [
    '$constant',
  ],
  data() {
    return {
      tableHeaders: [
        {label: '氏名', column: 'name'},
        {label: '氏名（カナ）', column: 'name_kana'},
        {label: '店舗名', column: 'office'},
        {label: '部署名', column: 'department'},
        {label: 'ステータス', column: 'status'},
      ],
    }
  },
  computed: {
    ...mapState('broker_index', [
      'brokers',
      'paginationStatus',
      'sortStatus',
    ]),
    ...mapState('account', [
      'is_supervisor',
    ]),
    tableData() {
      return this.brokers.map(broker => {
        return {
          id: broker.id,
          name: broker.name,
          'name.badge': broker.is_supervisor ? {text: '管理者', class:'bg-danger'} : null,
          name_kana: broker.name_kana,
          office: broker.office,
          department: broker.department,
          status: this.$constant.BROKER_STATUS_LIST.find(status => status.value === broker.status)?.text ?? '',
        }
      })
    },
  },
  methods: {
    ...mapMutations('broker_index', [
      'setSortColumn',
      'setCurrentPage',
      'setPerPage',
    ]),
    loadPage() {
      if (this.paginationStatus.per_page === null) {
        this.setPerPage({value: this.$constant.PAGINATION.PER_PAGE});
      }
      return this.$store.dispatch('broker_index/load').catch(reason => this.$root.failApi(reason));
    },
    doSearch() {
      this.setCurrentPage({value: 1});
      this.loadPage();
    },
    doReset() {
      this.$store.commit('broker_index/resetForms');
    },
    doChangePage(page) {
      this.setCurrentPage({value: page});
      this.loadPage();
    },
    doSort(column) {
      this.setSortColumn({column: column});
      this.loadPage();
    },
    toInvite() {
      this.$router.push({name: 'BrokerInvite'})
    },
    toDetail(id) {
      this.$router.push({name: 'BrokerViewer', params: {'id': id}})
    },
    toViewer() {
      this.$router.push({name: 'BrokerageCompanyViewer'});
    },
  }
}
</script>
